import { React, useState, useRef, useContext, useEffect } from "react";
import '../../css/Login.css';
import Footer from '../Layout/Footer';
import Swal from "sweetalert2";
import axios from "axios";
import { useNavigate } from "react-router-dom";
// ✅ isTablet 추가
import { isBrowser, isIOS, isAndroid, isMobile, isTablet } from 'react-device-detect';
import { useMediaQuery } from 'react-responsive';
import LogResModal from '../../common/LogResModal';
import { AppContext } from '../../AppStore';
import { useParams } from 'react-router-dom';

const Login = () => {
    // 아이디 저장: localStorage.clear()의 영향을 받지 않도록 쿠키에 저장
    const getSavedId = () => {
        const m = document.cookie.match(/(?:^|; )saved_login_id=([^;]*)/);
        return m ? decodeURIComponent(m[1]) : '';
    };
    const setSavedId = (id) => {
        // 365일 유지
        document.cookie = "saved_login_id=" + encodeURIComponent(id) +
            "; path=/; max-age=" + (365 * 24 * 60 * 60) + "; SameSite=Lax";
    };
    const clearSavedId = () => {
        document.cookie = "saved_login_id=; path=/; max-age=0; SameSite=Lax";
    };

    const params = useParams();
    const appStore = useContext(AppContext);
    const navigate = useNavigate();
    const [inputs, setInputs] = useState(() => {
        const _sid = getSavedId();
        return { id: _sid, password:'' };
    });
    const [rememberId, setRememberId] = useState(
        getSavedId() !== ''
    );
    const idRef = useRef(null);
    const rememberIdRef = useRef(null);
    const passwordRef = useRef(null);
    const [settingYN, setSettingYN] = useState('');
    const [companyName, setCompanyName] = useState('');
    const widthPC = useMediaQuery({ query: '(min-width: 1440px)' });
    const widthMobile = useMediaQuery({ query: '(max-width: 767px)' });
    const widthTablet = useMediaQuery({ query: '(min-width: 768px) and (max-width: 1439px)'});
    const [isModalOpen, setModalOpen] = useState(false);
    const [resourceCount, setResourceCount] = useState('');
    const [resourceList, setResourceList] = useState('');
    const retryTimerRef = useRef(null);
    const serverErrorAlertedRef = useRef(false);
    const RETRY_DELAY_MS = 10000;
    // diff_uuid 먼저 계산 (쿠키 값 없으면 새로 생성)   
    let diff_uuid = (document.cookie.split(';')
        .map(c => c.trim())
        .find(c => c.startsWith('diff_uuid='))?.split('=')[1]) 
    || Array.from(crypto.getRandomValues(new Uint8Array(30)))
        .map(b => (b % 36).toString(36)).join('');

    if (!document.cookie.includes('diff_uuid=')) {
        let cookieBase = `diff_uuid=${diff_uuid}; path=/; max-age=${60 * 60 * 24 * 365 * 2}; samesite=lax`;

        if (window.location.protocol === 'https:') {
            document.cookie = `${cookieBase}; secure`;  // HTTPS secure 적용
        } else {
            document.cookie = cookieBase;               // HTTP secure 제외
        }
    }
    
    var titleSize = '';
    var LoginMap = null;
    var imgWidth = '';
    var inputWidth = '';
    var containerWidth = '';
    let deviceType = 'P';
    let controlCompanyID = '';
    let controlCompanyNM = '';

    if(isMobile && widthMobile){
        // Mobile
        titleSize = '36px';
        imgWidth = '250px'
        inputWidth = '228px'
        containerWidth = '280px';
    }else if(widthTablet && !isBrowser){
        // Tablet
        titleSize = '42px';
        imgWidth = '330px';
        inputWidth = '323px'
        containerWidth = '380px';
    }else{
        // PC
        titleSize = '48px';
        imgWidth = '330px';
        inputWidth = '323px'
        containerWidth = '430px';
    }

    useEffect(() => {
        // Mount 될때만 실행된다.
        Swal.close(); 
        appStore.setLoading(false);
        
        const clearRetryTimer = () => {
            if (retryTimerRef.current) {
                clearTimeout(retryTimerRef.current);
                retryTimerRef.current = null;
            }
        };

        const fetchCompanyInfo = () => {
            axios.get('/api/Common/LoginCompanyInfo', {
                params: {
                    company_id: params.company_id != null
                                ? params.company_id
                                : (params.diff_token != null && params.diff_token.length < 20
                                    ? params.diff_token
                                    : ''),
                    diff_token: (params.diff_token != null && params.diff_token.length === 20)
                                ? params.diff_token
                                : '',
                    diff_uuid: diff_uuid
                }
            })
            .then((response) => { 
                clearRetryTimer();
                serverErrorAlertedRef.current = false;

                if(String(response.data) !== '-1'){
                    if(String(((response.data).split('$'))[2]) === 'MES'){
                        document.title = "MES";
                    }else{
                        document.title = String(((response.data).split('$'))[2]) + " MES";
                    }
                    controlCompanyID = ((response.data).split('$'))[0];
                    controlCompanyNM = ((response.data).split('$'))[1];
                    localStorage.setItem("control_company_nm", (((response.data).split('$'))[1]));
                    setCompanyName(((response.data).split('$'))[2]);
                    setSettingYN('Y');

                    if(params.diff_token !== null && typeof params.diff_token !== 'undefined' && (params.diff_token).length == 20){
                        // 토큰으로 들어오면 기존 세션 로그아웃 처리.
                        if (localStorage.length > 0){
                            axios.post("/api/Auth/Logout", new URLSearchParams({
                                type: 'C'
                            }),
                            { withCredentials: true })
                            .then(function (response) {
                                localStorage.clear();
                            })
                            .catch(function (error) {
                                console.log("네트워크 실패", error);
                            })
                            .then(function () {
                                TokenLogin();
                            });
                        }else{
                            TokenLogin();
                        }
                    }
                }else{
                    setSettingYN('S');
                    document.title = "Login 설정 오류";
                    if(isMobile && widthMobile){
                        alert('설정에 오류가 있어 로그인 할 수 없습니다.')
                    }else{
                        Swal.fire({
                            title: '<p style="color:red">설정 오류</p>',
                            text: '설정에 오류가 있어 로그인 할 수 없습니다.',
                            confirmButtonText: '확인',
                            confirmButtonColor: '#7066e0',
                            timer:5000,
                            timerProgressBar: true
                        });
                    }
                }
            })
            .catch((error) => {
                setSettingYN('N');
                document.title = "Login 서버 오류";
                if(isMobile && widthMobile){
                    //alert('서버에 오류가 있어 로그인 할 수 없습니다.')
                }else if(!serverErrorAlertedRef.current){
                    Swal.fire({
                        title: '<p style="color:red">서버 오류</p>',
                        text: '서버에 오류가 있어 로그인 할 수 없습니다.',
                        confirmButtonText: '확인',
                        confirmButtonColor: '#7066e0'
                    });
                    serverErrorAlertedRef.current = true;
                }
                scheduleRetry();
            });
        };

        const scheduleRetry = () => {
            clearRetryTimer();
            retryTimerRef.current = window.setTimeout(() => {
                fetchCompanyInfo();
            }, RETRY_DELAY_MS);
        };

        fetchCompanyInfo();

        return () => {
            clearRetryTimer();
        };
    }, [])

    useEffect(() => {
        if (settingYN === 'Y') {
            idRef.current && idRef.current.focus();
        }
    }, [settingYN]);

    const TokenLogin = () => {
        // ✅ 기기 고유값 기준으로 디바이스 판별 (TokenLogin)
        if (isTablet) {
            deviceType = 'T';
        } else if (isMobile) {
            deviceType = isAndroid ? 'A' : isIOS ? 'I' : 'M';
        } else {
            deviceType = 'P';
        }

        axios.post("/api/Auth/Login", new URLSearchParams({
            login_gubun: 'P',
            login_id: '',
            login_pw: '',
            login_uuid: diff_uuid,
            login_resource_id: '',
            login_diff_token: params.diff_token,
            login_type: '3'
        }),
        { withCredentials: true })
        .then(async function (response) {
            if(response.data.status === 'Y' || response.data.status === 'J'){
                // 리소스 로그인은 없으며, 중복로그인도 없다.
                axios.post("/api/Auth/LoginSuccess", new URLSearchParams({
                    login_gubun: '',
                    login_id: '',
                    login_pw: '',
                    login_uuid: diff_uuid,
                    login_resource_id: '',
                    login_diff_token: params.diff_token,
                    login_type: '3'
                }),
                { withCredentials: true })
                .then(async function (response) {
                    LoginMap = response.data;
                    await FetchTokenNav(LoginMap);
                    LoginSucPrc();
                })
                .catch(function (error) {
                    console.log("네트워크 실패", error);
                });
            }else if(response.data.status === 'I'){
                Swal.fire({
                    title: '<p style="color:red">접속 오류</p>',
                    text: '접속 허용된 IP가 아닙니다.',
                    confirmButtonText: '확인',
                    confirmButtonColor: '#7066e0',
                    timer: 5000,
                    timerProgressBar: true
                }).then((result) => {
                    LoginMap = null;
                });
            }else if(response.data.status === 'E'){
                // 자동 로그인 링크(토큰)가 정상적으로 만료된 경우 → 오류가 아닌 안내로 처리
                Swal.fire({
                    title: '<p style="color:#2f6fed">자동 로그인 만료</p>',
                    text: '자동 로그인 링크가 만료되었습니다.',
                    confirmButtonText: '확인',
                    confirmButtonColor: '#7066e0',
                    timer: 5000,
                    timerProgressBar: true
                }).then((result) => {
                    LoginMap = null;
                    setSettingYN('Y'); // 일반 로그인 폼 노출
                });
            }else if(response.data.status === 'N'){
                Swal.fire({
                    title: '<p style="color:red">접속 오류</p>',
                    text: '잘못된 토큰 정보 입니다.',
                    confirmButtonText: '확인',
                    confirmButtonColor: '#7066e0',
                    timer: 5000,
                    timerProgressBar: true
                }).then((result) => {
                    LoginMap = null;
                });
            }else if(response.data.status === 'L'){
                Swal.fire({
                    title: '<p style="color:red">접속 오류</p>',
                    text: '유효한 라이센스 정보가 없습니다.',
                    confirmButtonText: '확인',
                    confirmButtonColor: '#7066e0',
                    timer: 5000,
                    timerProgressBar: true
                }).then((result) => {
                    LoginMap = null;
                });
            }else{
                Swal.fire({
                    title: '<p style="color:red">접속 오류</p>',
                    text: '알 수 없는 오류 입니다.',
                    confirmButtonText: '확인',
                    confirmButtonColor: '#7066e0',
                    timer: 5000,
                    timerProgressBar: true
                }).then((result) => {
                    LoginMap = null;
                });
            }
        })
        .catch(function (error) {
            setSettingYN('N');
            LoginMap = null;
            console.log("네트워크 실패", error);
        });
    }

    const FetchTokenNav = async (loginMap) => {
        if(!loginMap || loginMap.status !== 'Y'){
            return;
        }
        
        // ✅ 기기 고유값 기준으로 디바이스 판별 (FetchTokenNav)
        let type = 'P';
        if (isTablet) {
            type = 'T';
        } else if (isMobile) {
            type = isAndroid ? 'A' : isIOS ? 'I' : 'M';
        } else {
            type = 'P';
        }

        const targetUrl = (type === 'A' || type === 'I') ? (loginMap.target_m_url || '/m') : (type === 'T') ? (loginMap.target_t_url || '/t') : (loginMap.target_p_url || '/p');
        try{
            const response = await axios.post("/api/Auth/TokenUpdate", new URLSearchParams({
                DiffToken: loginMap.DiffToken,
                TokenTime: loginMap.TokenTime,
                user_id: loginMap.user_id.trim(),
                user_login_token: loginMap.user_login_token,
                menu_url: targetUrl,
                device_type: (type === 'A' || type === 'I') ? 'M' : type
            }), { withCredentials: true });
            if(response.data && response.data.nav){
                localStorage.setItem("nav", response.data.nav);
            }
        }catch (error){
            console.log("네트워크 실패", error);
        }
    };

    const onChange = (e)=>{
        const {name, value} = e.target;
        const nextInputs = {
            ...inputs,
            [name]: value, //e.target의 name과 value이다.
        };

       setInputs(nextInputs)
    }

    const onReset = () => {
        setInputs({
            id:'',
            password:''
        });
    }

    const activeEnter = (e, type) => {
        if(type === 'id' && e.key === "Enter" && inputs.id !== '') {
            return passwordRef.current.focus();
        }
        // 비밀번호 Enter는 form onSubmit이 처리 (중복 호출 방지)
    }

    const modalClose = () => {
        setModalOpen(false);
    };
    
    const handleSelectLogin = (resourceID) => {
        LoginAuth("LoginSuccess", resourceID)
    };

    // API 호출 함수
    const LoginAuth = (location, resourceID) => {
        if (inputs.id !== '' && inputs.password !== ''){
            LoginPrc(location, resourceID);
        }
    };

    const LoginPrc = (location, resourceID) => {
        axios.post("/api/Auth/"+location, new URLSearchParams({
            login_gubun: 'P',
            login_id: inputs.id.trim(),
            login_pw: inputs.password,
            login_uuid: diff_uuid,
            login_resource_id: resourceID,
            login_diff_token: '',
            login_type: '1'
        }),
        { withCredentials: true })
        .then(async function (response) {
            if(location == 'Login'){

                if(response.data.status === 'Y'){
                    if(response.data.resource_count === "0"){
                        LoginAuth("LoginSuccess", "")
                    }else{
                        setResourceList(String(response.data.resource_list));
                        setResourceCount(String(response.data.resource_count));
                        LoginResChk();
                    }
                }else if(response.data.status === 'I'){
                    Swal.fire({
                        title: '<p style="color:red">접속 오류</p>',
                        text: '접속 허용된 IP가 아닙니다.',
                        confirmButtonText: '확인',
                        confirmButtonColor: '#7066e0',
                        timer: 5000,
                        timerProgressBar: true
                    }).then((result) => {
                        LoginMap = null;
                    });
                }else if(response.data.status === 'N'){
                    Swal.fire({
                        title: '<p style="color:red">접속 오류</p>',
                        text: '아이디와 비밀번호를 다시 확인해주세요.',
                        confirmButtonText: '확인',
                        confirmButtonColor: '#7066e0',
                        timer: 5000,
                        timerProgressBar: true
                    }).then((result) => {
                        LoginMap = null;
                    });
                }else if(response.data.status === 'L'){
                    Swal.fire({
                        title: '<p style="color:red">접속 오류</p>',
                        text: '유효한 라이센스 정보가 없습니다.',
                        confirmButtonText: '확인',
                        confirmButtonColor: '#7066e0',
                        timer: 5000,
                        timerProgressBar: true
                    }).then((result) => {
                        LoginMap = null;
                    });
                }else{
                    Swal.fire({
                        title: '<p style="color:red">접속 오류</p>',
                        text: '알 수 없는 오류 입니다.',
                        confirmButtonText: '확인',
                        confirmButtonColor: '#7066e0',
                        timer: 5000,
                        timerProgressBar: true
                    }).then((result) => {
                        LoginMap = null;
                    });
                }

            }else if(location == 'LoginSuccess'){
                if(response.data.status === "N"){
                    Swal.fire({
                        title: '<p style="color:red">접속 오류</p>',
                        text: '아이디와 비밀번호를 다시 확인해주세요.',
                        confirmButtonText: '확인',
                        confirmButtonColor: '#7066e0',
                        timer: 5000,
                        timerProgressBar: true
                    }).then((result) => {
                        LoginMap = null;
                    });
                }else if(response.data.status === "J"){
                    Swal.fire({
                        title: '<p style="color:red">중복 로그인</p>',
                        html : '다른 기기에서 로그인중 입니다. 강제로 로그아웃하고, 로그인 하시겠습니까?',
                        showCancelButton : true,
                        confirmButtonClass : "btn-danger",
                        confirmButtonText : "확인",
                        cancelButtonText : "취소"
                    }).then((result) => {
                        if (result.isConfirmed) {
                            axios.post("/api/Auth/LoginSuccess", new URLSearchParams({
                                login_gubun: 'P',
                                login_id: inputs.id,
                                login_pw: inputs.password,
                                login_resource_id: resourceID,
                                login_type: '2'
                            }),
                            { withCredentials: true })
                            .then(async function (response) {
                                LoginMap = response.data;
                                if(String(LoginMap.user_login_kko_authority_yn) === 'Y' && (LoginMap.user_phone).match(/010-(\d{4})-(\d{4})/)){
                                    var returndata = await appStore.PHONE_AUTH(LoginMap.user_phone);
                                    if (String(returndata) === 'Y') {
                                        LoginSucPrc();
                                    }
                                }else{
                                    LoginSucPrc();
                                }
                            })
                            .catch(function (error) {
                                LoginMap = null;
                                console.log("네트워크 실패", error);
                            })
                        }else{
                            window.location.reload();
                        }
                    });
            
                }else if(response.data.status === "D"){
                    localStorage.setItem("LogoutType", 'D');
                    LoginMap = null;
                    navigate('/Logout');
                }else if(response.data.status === "Y"){
                    LoginMap = response.data;
                    // 아이디 저장 (로그인 성공 확정 시점에 즉시 기록)
                    try{
                        const rid = (idRef.current && idRef.current.value) ? idRef.current.value : inputs.id;
                        const rchk = rememberIdRef.current ? rememberIdRef.current.checked : rememberId;
                        if(rchk && String(rid).trim() !== ''){
                            setSavedId(String(rid).trim());
                        }else{
                            clearSavedId();
                        }
                    }catch(e){ console.log("saved_login_id 오류", e); }
                    if(String(LoginMap.user_login_kko_authority_yn) === 'Y' && (LoginMap.user_phone).match(/010-(\d{4})-(\d{4})/)){
                        var returndata = await appStore.PHONE_AUTH(LoginMap.user_phone);
                        if (String(returndata) === 'Y') {
                            LoginSucPrc();
                        }
                    }else{
                        LoginSucPrc();
                    }
                }
                
            }
        })
        .catch(function (error) {
            console.log("네트워크 실패", error);
        })
        .then(function () {
            // 항상 실행
        });
    }

    const LoginResChk = () => {
        // 자원, 사용자 로그인 체크
        LoginAuth("LoginSuccess", "")
    }
    const LoginSucPrc = () => {
        // ✅ 기기 고유값 기준으로 디바이스 판별 (LoginSucPrc)
        if (isTablet) {
            deviceType = 'T';
        } else if (isMobile) {
            deviceType = isAndroid ? 'A' : isIOS ? 'I' : 'M';
        } else {
            deviceType = 'P';
        }

        const isAppWebView = !!(window.Android && typeof window.Android.setCompanyUser === "function");

        // ★ 카카오톡 연결 중이면 설치 안내를 건너뛴다.
        //   (1) 카카오톡 인앱 브라우저라 APK 를 받아도 설치로 이어지지 않는다.
        //   (2) 더 중요한 건, 아래에서 "확인"을 누르면 return 으로 빠져서
        //       로그인 뒷부분(returnUrl 복귀)이 통째로 실행되지 않는다.
        //       그러면 카카오 연결이 거기서 끊긴다.
        let isKkoLinkFlow = false;
        try {
            isKkoLinkFlow = (sessionStorage.getItem("returnUrl") || "").indexOf("kkolink=") >= 0;
        } catch (e) {}

        // 앱(WebView)으로 접속하면 묻지 않음. 웹브라우저(모바일/태블릿)에만 "하루 1회" 설치 안내.
        // (영구로 안 묻으면 다운로드 통로가 사라지므로, 날짜 기준으로 하루 1번만 묻는다)
        if ((String(deviceType) === "A" || String(deviceType) === "T") && !isAppWebView && !isKkoLinkFlow) {
            let lastAskDate = '';
            try { lastAskDate = localStorage.getItem("apk_prompt_date") || ''; } catch (e) {}
            const today = new Date().toISOString().slice(0, 10);   // YYYY-MM-DD
            if (lastAskDate !== today) {
                try { localStorage.setItem("apk_prompt_date", today); } catch (e) {}   // 취소해도 오늘은 다시 안 물음
                if (window.confirm("어플리케이션을 다운로드 하시겠습니까?")) {
                    window.open("https://mes.itdiff.com/static/apk/"+LoginMap.control_company_id+".apk", "_blank");
                    return;
                }
            }
        }
        
        // 로그인 성공
        localStorage.setItem("expire_dt", new Date().getTime() + (14 * 24 * 60 * 60 * 1000));
        localStorage.setItem("company_id", LoginMap.company_id);
        localStorage.setItem("company_nm", LoginMap.company_nm);
        localStorage.setItem("company_code_type", LoginMap.company_code_type);
        localStorage.setItem("control_company_id", LoginMap.control_company_id);
        localStorage.setItem("control_company_nm", LoginMap.control_company_nm);
        localStorage.setItem("main_screen_type", LoginMap.main_screen_type);
        localStorage.setItem("workplace_id", LoginMap.workplace_id);
        localStorage.setItem("workplace_nm", LoginMap.workplace_nm);
        localStorage.setItem("user_id", LoginMap.user_id);
        localStorage.setItem("user_login_id", LoginMap.user_login_id);
        // 아이디 저장 처리 (쿠키에 저장 → localStorage.clear() 영향 없음)
        const currentId = (idRef.current && idRef.current.value ? idRef.current.value : inputs.id) || '';
        const currentRemember = rememberIdRef.current ? rememberIdRef.current.checked : rememberId;
        if(currentRemember && String(currentId).trim() !== ''){
            setSavedId(String(currentId).trim());
        }else{
            clearSavedId();
        }
        localStorage.setItem("user_login_token", LoginMap.user_login_token);
        localStorage.setItem("user_nm", LoginMap.user_nm);
        localStorage.setItem("user_en_nm", LoginMap.user_en_nm);
        localStorage.setItem("user_status", LoginMap.user_status);
        localStorage.setItem("user_status_nm", LoginMap.user_status_nm);
        localStorage.setItem("emp_no", LoginMap.emp_no);
        localStorage.setItem("user_email", LoginMap.user_email);
        localStorage.setItem("user_call", LoginMap.user_call);
        localStorage.setItem("user_phone", LoginMap.user_phone);
        localStorage.setItem("user_nickname", LoginMap.user_nickname);
        localStorage.setItem("user_birth_date", LoginMap.user_birth_date);
        localStorage.setItem("user_dept_id", LoginMap.user_dept_id);
        localStorage.setItem("user_dept_nm", LoginMap.user_dept_nm);
        localStorage.setItem("user_position", LoginMap.user_position);
        localStorage.setItem("user_position_nm", LoginMap.user_position_nm);
        localStorage.setItem("user_duty", LoginMap.user_duty);
        localStorage.setItem("user_duty_nm", LoginMap.user_duty_nm);
        localStorage.setItem("user_img", LoginMap.user_img);
        localStorage.setItem("user_img_sever", LoginMap.user_img_sever);
        localStorage.setItem("user_card_img", LoginMap.user_card_img);
        localStorage.setItem("user_card_img_sever", LoginMap.user_card_img_sever);
        localStorage.setItem("user_sign_img", LoginMap.user_sign_img);
        localStorage.setItem("user_sign_img_sever", LoginMap.user_sign_img_sever);
        localStorage.setItem("user_login_kko_authority_yn", LoginMap.user_login_kko_authority_yn);
        localStorage.setItem("user_cross_login_yn", LoginMap.user_cross_login_yn);
        localStorage.setItem("Auth", 'Y');
        localStorage.setItem("TokenTime", LoginMap.TokenTime);
        localStorage.setItem("DiffToken", LoginMap.DiffToken);
        localStorage.setItem("resource_id", LoginMap.resource_id);
        localStorage.setItem("resource_name", LoginMap.resource_name);
        localStorage.setItem("resource_number", LoginMap.resource_number);
        localStorage.setItem("deviceType", (deviceType === 'A' || deviceType === 'I')?'M':deviceType === 'T'?'T':'P');
        localStorage.setItem("deviceDetailType", deviceType);
        localStorage.setItem("target_p_url", LoginMap.target_p_url);
        localStorage.setItem("target_t_url", LoginMap.target_t_url);
        localStorage.setItem("target_m_url", LoginMap.target_m_url);
        localStorage.setItem("kpi_basis_yn", LoginMap.kpi_basis_yn);

        // Android bridge 회사, 사용자 정보 전달
        try {
            const companyId = Number(LoginMap.company_id);
            const userId = Number(LoginMap.user_id);

            const deviceTypeForServer = (deviceType === 'A' || deviceType === 'I') ? 'M' : (deviceType === 'T' ? 'T' : 'P');

            // Android 브릿지가 있을 때만 호출됨 (웹 브라우저에서는 window.Android 없음)
            if (window.Android && typeof window.Android.setCompanyUser === 'function') {
                window.Android.setCompanyUser(companyId, userId);
            }
        } catch (e) {
            // 웹에서는 그냥 무시
            console.log("FCM register skipped:", e);
        }
        
        //diff_uuid 쿠키 저장.
        let cookieBaseDB = `diff_uuid=${LoginMap.user_uuid}; path=/; max-age=${60 * 60 * 24 * 365 * 2}; samesite=lax`;
        if (window.location.protocol === 'https:') {
            document.cookie = `${cookieBaseDB}; secure`;   // HTTPS secure 적용
        } else {
            document.cookie = cookieBaseDB;                // HTTP secure 제외
        }

       // ★ 저장된 딥링크 복귀 (알림으로 들어온 경우). 기기 타입과 경로 prefix가 맞을 때만 사용
       let returnUrl = '';
       try { returnUrl = sessionStorage.getItem("returnUrl") || ''; } catch (e) {}
       try { sessionStorage.removeItem("returnUrl"); } catch (e) {}

       if (String(deviceType) === 'A' || String(deviceType) === 'I' || String(deviceType) === 'M') {
            localStorage.setItem("main", "/m");
            navigate(returnUrl && returnUrl.startsWith('/m') ? returnUrl
                     : (LoginMap.target_m_url ? String(LoginMap.target_m_url) : '/m'));
        } else if (String(deviceType) === 'T') {
            localStorage.setItem("main", "/t");
            navigate(returnUrl && returnUrl.startsWith('/t') ? returnUrl
                     : (LoginMap.target_t_url ? String(LoginMap.target_t_url) : '/t'));
        } else {
            localStorage.setItem("main", "/p");
            navigate(returnUrl && returnUrl.startsWith('/p') ? returnUrl
                     : (LoginMap.target_p_url ? String(LoginMap.target_p_url) : '/p'));
        }
    }

    return (
        <div style={ { width:'100%', display: 'block' } }>
            <div className="container" style={ {width:containerWidth  } }>
                {/*<img width={ imgWidth } src={`${process.env.PUBLIC_URL}/logo.png`} />*/}
                
                {String(settingYN) === String('') || String(settingYN) === String('N') || String(settingYN) === String('S') ?
                String(settingYN) === String('')?
                <>
                <h1 style={ { fontWeight:'bold', fontSize: '32px', padding: '10px', paddingBottom: '20px', margin: '0px', color:'blue' } }>서버 로딩중</h1>
                </>
                :
                String(settingYN) === String('S')?
                <>
                <h1 style={ { fontWeight:'bold', fontSize: '32px', padding: '10px', paddingBottom: '20px', margin: '0px', color:'red' } }>설정 오류</h1>
                </>
                :
                <>
                <h1 style={ { fontWeight:'bold', fontSize: '32px', padding: '10px', paddingBottom: '20px', margin: '0px', color:'red' } }>서버 오류</h1>
                </>
                :
                <>
                <h1 style={ { fontWeight:'bold', fontSize: titleSize, padding: '10px', paddingBottom: '20px', margin: '0px' } }>{ companyName }</h1>
                <form onSubmit={(e) => { e.preventDefault(); LoginAuth("Login", ""); }}>
                <div className="login_input">
                    <input type="text" name="id" placeholder="아이디" style={ { width: inputWidth } } value={inputs.id} onChange={onChange} ref={idRef} onKeyUp={(e) => activeEnter(e, 'id')} autoComplete="username" />
                    <input type="password" name="password" placeholder="비밀번호" style={ { width: inputWidth } } value={inputs.password} onChange={onChange} ref={passwordRef} onKeyUp={(e) => activeEnter(e, 'password')} autoComplete="current-password" />
                </div>
                <div className="login_remember" style={ { width: inputWidth, margin: '0 auto', textAlign: 'left', padding: '0 2px 6px', marginTop: '-4px' } }>
                    <label style={ { fontSize: '14px', cursor: 'pointer', userSelect: 'none', display: 'inline-flex', alignItems: 'center' } }>
                        <input type="checkbox" ref={rememberIdRef} checked={rememberId} onChange={(e) => { setRememberId(e.target.checked); if(!e.target.checked){ clearSavedId(); } }} style={ { marginRight: '6px' } } />
                        아이디 저장
                    </label>
                </div>
                <div className="submit_button" style={ { paddingBottom: '10px' } }>
                    <input type="button" value="로그인" style={ { width: imgWidth } } onClick={ ()=> LoginAuth("Login", "") } />
                    {/* 브라우저 비밀번호 관리자 트리거용 숨은 submit */}
                    <button type="submit" style={ { display: 'none' } } aria-hidden="true" tabIndex={-1}></button>
                </div>
                </form>
                </>
                }
            </div>
            {isModalOpen && (
                <LogResModal modalClose={modalClose} handleSelectLogin={handleSelectLogin} resourceCount={resourceCount} resourceList={resourceList} />
            )}
        <Footer />
        </div>
    )
}

export default Login;